// SIC currency lock — 30-day cookie that overrides Shopify Markets auto-detect
// after the user's first page view. Stops mid-session €→$ flips that kill trust.
//
// Drops into theme.liquid before the closing </body>, OR upload as
// assets/currency-lock.js and reference with a defer'd script tag.
//
// 2026-05-01 patch: include `_method=put` on the POST to /localization (Rails-style
// method override; without it Shopify returns 404). Also clear the lock cookie when
// the user clicks the country picker, so the new country's currency wins instead of
// being immediately reverted.

(function () {
  'use strict';

  var COOKIE_KEY = 'sic_currency_lock';
  var COOKIE_DAYS = 30;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
  function writeCookie(name, val, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + encodeURIComponent(val) +
      '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function clearCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';
  }

  function detectActiveCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    var meta = document.querySelector('meta[name="shopify-currency"]');
    return meta ? meta.getAttribute('content') : null;
  }

  function applyCurrency(code) {
    if (!code) return;
    if (window.Shopify && Shopify.currency && Shopify.currency.active === code) return;

    // Shopify's /localization endpoint requires _method=put — without it returns 404.
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.enctype = 'multipart/form-data';
    form.style.display = 'none';
    form.innerHTML =
      '<input type="hidden" name="form_type" value="currency">' +
      '<input type="hidden" name="_method" value="put">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="currency_code" value="' + code + '">' +
      '<input type="hidden" name="return_to" value="' + location.pathname + location.search + '">';
    document.body.appendChild(form);
    form.submit();
  }

  // ───── boot ─────
  var locked = readCookie(COOKIE_KEY);

  if (locked) {
    var active = detectActiveCurrency();
    if (active && active !== locked) {
      applyCurrency(locked);
    }
  } else {
    var active2 = detectActiveCurrency();
    if (active2) writeCookie(COOKIE_KEY, active2, COOKIE_DAYS);
  }

  // ───── user-driven changes ─────
  // Currency selector (rare): persist new value
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (sel && sel.name === 'currency_code') {
      writeCookie(COOKIE_KEY, sel.value, COOKIE_DAYS);
    }
  });

  // Country picker (the top-left chooser): clicking a country button changes both
  // country and currency. Clear the lock so the new currency wins on the next page —
  // otherwise the boot logic above would immediately revert the user's choice and 404.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="country_code"]');
    if (btn) {
      clearCookie(COOKIE_KEY);
    }
  });

  // ───── automatic first-order offer messaging ─────
  // The store now uses an automatic 20% discount for first-time customers.
  // Keep all customer-facing copy code-free and unambiguous.
  function syncAutomaticOfferMessaging() {
    var bar = document.querySelector('.sic-shipping-bar');
    if (bar) {
      bar.setAttribute('aria-label', 'First-order offer and shipping');
      bar.innerHTML = '<p style="margin:0">' +
        '<strong style="display:block;font-size:.95rem;font-weight:800;letter-spacing:.06em;line-height:1.25">20% OFF YOUR FIRST ORDER — AUTOMATICALLY APPLIED · NO ITEM LIMIT</strong>' +
        '<span style="display:block;margin-top:.22rem;font-size:.73rem;font-weight:650;letter-spacing:.035em;opacity:.96">FREE STANDARD SHIPPING WORLDWIDE · DUTIES &amp; TAXES INCLUDED</span>' +
        '<span style="display:block;margin-top:.12rem;font-size:.68rem;letter-spacing:.015em;opacity:.82">Made to order · Dispatches in 5–7 business days · Tracked delivery</span>' +
        '</p>';
    }

    document.querySelectorAll('.sic-welcome-offer').forEach(function (el) {
      el.innerHTML = '<strong>20% off your first order — applied automatically.</strong>';
      el.setAttribute('aria-label', '20% off your first order — applied automatically.');
    });

    var popupSubhead = document.querySelector('#sic-popup-root .sic-subhead');
    if (popupSubhead) {
      popupSubhead.textContent = 'Your 20% first-order discount is applied automatically at checkout.';
    }

    document.querySelectorAll('.email-popup__sub--ps').forEach(function (el) {
      el.textContent = 'No sale blasts — we don’t run them. Just the letter, and 20% off your first order, applied automatically.';
    });

    var sticky = document.getElementById('sticky-tab');
    if (sticky) {
      sticky.setAttribute('aria-label', '20% off your first order — applied automatically');
    }
  }

  syncAutomaticOfferMessaging();
})();
